import React, { useState, useContext } from 'react';
import axios from 'axios';
import { Link,useNavigate } from 'react-router-dom';
import { AuthContext } from './authcontext';
import karwan from "../images/karvaan.jpg";
import { BASE_URL } from '../utils/utils';
import GoogleLoginButton from '../google/google';
const AuthManager = () => {
    const { isLoggedIn, handleLogin } = useContext(AuthContext);
    // console.log('isLoggedIn:', isLoggedIn); // Check the value of isLoggedIn
    // console.log('handleLogin:', handleLogin); // Check the value of handleLogin
    // console.log('handleLogout:', handleLogout); // Check the value of handleLogout
    const [username, setUsername] = useState('');
    const [success, setSuccessMessage] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    
    const handleLoginClick = async (username, password) => {
        try {
            const response = await axios.post(`${BASE_URL}/accounts/api/token/`, {
                username: username,
                password: password,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const { access, refresh,  author_or_not } = response.data;
            handleLogin(access, refresh, author_or_not);
            setSuccessMessage('Login successful.');
            setError(null);
        } catch (error) {
          setError(error.response.request.response);
        }
    };

    const handleRedirectToHome = () => {
        navigate('/home')
    };

    return (
        <div>
  {isLoggedIn ? (
    <div>
      {handleRedirectToHome()}
      </div>
  ) : (
    <div>
      <GoogleLoginButton/>
      <div>
        <img src={karwan} alt="Logo" className="logo" />
      </div>
      {error?error:''}
      <hr className="horizontal-line" />
      <br />
      <br />
      
      <div className="heading-align">
        <h1 id="stylish">Login to your Karvan account</h1>
        <div className="textbox-input">
          <div className="input-group-username">
            <label htmlFor="username">Email:</label>
            <input
              type="text"
              id="username"
              placeholder="Enter your email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="input-group-password">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button className="btn-signup" onClick={async () => handleLoginClick(username, password)}>
            Login
          </button>
        </div>
        <div className="container">
          <div className="textbox">
            <p>Don't have an account? <Link to="/signup">Signup here.</Link></p>
          </div>
        </div>
      </div>
    </div>
  )}
</div>

    );
};

export default AuthManager;
